module.exports = __webpack_public_path__ + "assets/img/xw-logo.1e03b091.png";